/**
 * Safely slices a string without breaking emojis or complex characters.
 * Uses Intl.Segmenter if available, falls back to basic slice otherwise.
 *
 * @param str - The string to slice + '...' if the string is longer than the limit
 * @param limit - The maximum number of characters/graphemes to return
 * @returns The sliced string
 */
export function safeSlice(str: string, limit: number): string {
  if (typeof Intl !== 'undefined') {
    if (typeof Intl.Segmenter === 'function') {
      const segmenter = new Intl.Segmenter()
      const graphemes = Array.from(segmenter.segment(str), (s) => s.segment)
      const graphemesLength = graphemes.length
      if (graphemesLength <= limit) {
        return str
      }
      return graphemes.slice(0, limit).join('') + '...'
    }
  }

  // Fallback: basic slice (may cut emojis in rare cases)
  return str.slice(0, limit) + (str.length > limit ? '...' : '')
}
